import {validationMixin} from "vuelidate";
import httpClient from "../../http";
import {mapGetters} from "vuex";
import {validationMessage} from "vuelidate-messages";
import {formMessages} from "../../utils/validationMessages";
import EventBus from "../../bus";
import UIConstants from "../../store/ui/constants";
import {USER_GROUPS} from "@/store/auth/auth";

export const ObjectComponentMixin = {

    mixins: [ validationMixin ],
    validations() {
        return this.objectClass ? { form: this.objectClass.validations } : {}
    },
    props: {
        changesCanceled: { type: Boolean, default: false }
    },
    data() {
        return {
            objectId: null,
            objectClass: null,
            apiEntryPoint: null,
            object: {},
            form: {},
            objectKey: new Date().getTime(),
            backRoute: null,
            nextRoute: null,
            initObjectParams: {}, // поля по умолчанию для инициализации пустого объекта
            initClassProperties: {}, // поля по умолчанию для инициализации класса
            objectData: null, // если задано, то запрос данных объекта по API не будет производиться, объект инициализируется

            // initialObject: null, // если задано, то запрос данных объекта по API не будет производиться, объект НЕ инициализируется
            // initialForm: null, // если задано, то запрос данных объекта по API не будет производиться, объект НЕ инициализируется

            // cancelInlineChanges: {}

            loading: false,
            failedLoading: false,
            hasChanges: false,
            silentLeave: false,

            // backRouteName: null

        }
    },
    computed: {
        ...mapGetters(['ability']),
        stub() {
            return Boolean(this.objectId) && this.loading
        },
        header() {
            if (this.object && this.objectClass) {
                if (this.object.id) {
                    return this.object.objectLabel();
                }
                return this.objectClass.newLabel;
            }
            return '-'
        },
        createUrl() {
            if (this.apiEntryPoint.hasOwnProperty('default')) {
                return this.apiEntryPoint.default.list();
            }
        },
        updateUrl() {
            if (this.apiEntryPoint.hasOwnProperty('default') && this.objectId) {
                return this.apiEntryPoint.default.detail(this.objectId);
            }
        },
        submitAction() {
            return this.object.id ? this.updateObject : this.createObject;
        },
    },
    methods: {
        getHeader(objectId) {
            if (objectId) {
                return this.object.objectLabel();
            }
            return this.objectClass.newLabel;
        },
        getHasChanges() {
            return this.hasChanges;
        },
        getSubmitAction(objectId) {
            return objectId ? this.updateObject : this.createObject;
        },
        getAbility(name = null) {
            // can('update', 'News', ['reviewComment']);
            // console.log(name, this.ability.can('update', this.object, name), this.object)
            // console.log(this.object.id, name, this.ability.can('update', this.objectClass.modelName), this.object)
            // console.log(this.ability.can('create', this.objectClass.modelName))
            if (this.object.id) {
                return name ? this.ability.can('update', this.object, name) : this.ability.can('update', this.object)
            }
            if (this.objectClass) {
                return this.ability.can('create', this.objectClass.modelName)
            }
            return false
        },
        back() {
            if (this.backRoute) {
                this.$router.replace({name: this.backRoute})
            } else {
                 this.$router.back()
            }
        },
        validateState(name) {
            let source;
            if (this.$v.form && this.$v.form.hasOwnProperty(name)) {
                source = this.$v.form[name];
            }
            // if (this.$v.dateForm && this.$v.dateForm.hasOwnProperty(name)) {
            //     source = this.$v.dateForm[name];
            // }
            if (!source) { return }
            const { $dirty, $error } = source;
            return $dirty ? !$error : null;
        },

        validationMessageText() {
            return validationMessage(formMessages, {dirty: true, first: 1})
        },
        liveFeedback(name) {
            if (this.$v.form) { return this.validationMessageText()(this.$v.form[name]) }
            return null
        },
        getValidationClass(name) {
            let res = this.validateState(name);
            if (res === null) { return '' }
            return res ? 'is-valid' : 'is-invalid';
        },
        getFieldLabel(name) {
            return this.objectClass.validationFieldLabels[name]
        },
        getObjectField(name) {
            return this.object[name]
        },

        onModelObjectSingleSelectChanged(name, item) {
            this.form[name] = item.id
            this.$v.form[name].$touch();
        },
        onModelObjectSingleSelectCleared(name) {
            this.form[name] = null;
            this.$v.form[name].$touch();
        },
        onModelObjectListAdded(name, item) {
            console.log(name, item, this.form)
            this.form[name].push(item.id)
            this.$v.form[name].$touch();
        },
        onModelObjectListRemoved(name, item) {
            this.form[name].splice(this.form[name].indexOf(item.id), 1);
            this.$v.form[name].$touch();
        },
        onModelObjectRadioChanged(name, item, data) {
            this.form[name] = item
            this.$v.form[name].$touch();
        },
        onModelDateChanged(date, fieldName) {
            if (this.form.hasOwnProperty(fieldName)) {
                this.form[fieldName] = date;
                this.$v.form[fieldName].$touch();
            }
        },

        fetchInitData() {
            return new Promise((resolve, reject) => {
                httpClient.get(this.updateUrl)
                .then(response => {
                    resolve(response.data)
                })
                .catch(reason => {
                    // vm.showErrorToast(reason);
                    reject(reason)
                })
            });
        },
        initForm() {
            this.form = new this.objectClass(this.initObjectParams, this.initClassProperties);
        },
        initObject() {
            const vm = this;
            this.object = new this.objectClass(this.initObjectParams, this.initClassProperties);
            this.loading = true;

            let dataPromise = new Promise((resolve => {
                resolve(vm.objectData);
            }));

            if (!vm.objectData && this.objectId) {
                dataPromise = this.fetchInitData();
            }

            dataPromise.then((data) => {

                let success = false;
                vm.loading = false;

                if (data && typeof vm.object['applyData'] === 'function') {
                    vm.applyData(data);
                    success = true;
                } else if (!vm.objectId && !data) {
                    success = true;
                }

                return new Promise((resolve, reject) => {
                    if (success) {
                        resolve()
                    } else {
                        reject()
                    }
                })
            }).catch(reason => { vm.showErrorToast(reason) });

            return dataPromise
        },
        applyData(data) {
            this.objectData = data;
            this.object.applyData(data);
            this.form.applyData(data);
        },
        getApiFieldName(name) {
            if (!this.objectClass.hasOwnProperty('mapping')) {
                return name;
            }
            if (this.objectClass.mapping.hasOwnProperty(name)) {
                return this.objectClass.mapping[name];
            }
            return name;
        },
        prepareData() {
            let data = {};
            for (const k in Object.keys(this.form)) {
                const i = Object.keys(this.form)[k];
                const apiFieldName = this.getApiFieldName(i);
                if (apiFieldName
                    && this.form.hasOwnProperty(i)
                    && this.$v.form.hasOwnProperty(i)) {
                    data[apiFieldName] = this.$v.form[i].$model;
                }
            }
            return data;
        },
        cancelChanges() {
            this.$v.$reset();

            this.form = new this.objectClass(this.initObjectParams, this.initClassProperties) //{...this.object};
            this.form.applyData(this.objectData);

            for (const i in this.$refs) {
                const ref = this.$refs[i];
                if (ref && ref.hasOwnProperty('reset')) {
                    ref.reset();
                }
                if (ref && ref.hasOwnProperty('cancelChanges')) {
                    ref.cancelChanges();
                }
            }

        },
        resetForm() {
            if (this.objectClass) {
                this.failedLoading = false;
                this.initForm();
                return this.initObject().then(resolve => { this.objectKey = new Date().getTime(); }).catch((reason) => { this.failedLoading = true });
            } else {
                console.log('Не задан тип объекта')
            }
        },
        resetFormDeferred() {
            return new Promise((resolve, reject) => {
                if (this.objectClass) {
                    this.initForm();
                    this.initObject().then(() => {
                        resolve()
                    }).catch(() => {
                        reject('???');
                    })
                } else {
                    reject('Не задан тип объекта');
                }
            })
        },
        setObjectData(data) {
            this.objectData = data
        },

        clearForm() {
            this.resetFormDeferred().then(() => {

                    for (const i in this.$refs) {
                        const ref = this.$refs[i];
                        if (ref && ref.hasOwnProperty('reset') && !ref.hasOwnProperty('clearForm')) {
                            ref.reset();
                        }
                        if (ref && ref.hasOwnProperty('clearForm')) {
                            ref.clearForm();
                        }
                    }

                    this.objectKey = new Date().getTime();

                    this.$v.$reset();

                }).catch((reason) => {
                    console.log(reason)
            })

        },

        onCreate(e) {
            this.createObject().then((result) => {
                if (e.back) {
                    this.$router.replace({name: this.backRoute})
                } else {
                    this.$router.replace({name: this.nextRoute, params: { id: result.objectId }})
                }
                this.loading = false;
            })
            this.loading = false;
        },

        createObject() {
            const vm = this;
            this.silentLeave = true;
            let data = this.prepareData();

            vm.loading = true;
            return new Promise((resolve, reject) => {
                httpClient.post(vm.createUrl, data)
                .then((response) => {
                    vm.$bvToast.toast('Объект создан',
                        {solid: true, noCloseButton: true, autoHideDelay: 5000, variant: 'success'});
                    const back = typeof vm.backRoute === 'object' ? vm.backRoute : { name: vm.backRoute };
                    const next = typeof vm.nextRoute === 'object' ? vm.nextRoute : { name: vm.nextRoute, params: { id: response.data.id } };
                    resolve({next: next, back: back, data: response.data, objectId: response.data['id']});
                })
                .catch((reason) => {
                    vm.showErrorToast(reason, vm.newLabel);
                    reject(reason)
                })
                .finally(() => {
                    vm.loading = false
                })
            })
        },
        updateObject() {
            const vm = this;

            vm.loading = true;

            let data = this.prepareData();
            const objectLabel = vm.object.objectLabel();
            return new Promise((resolve, reject) => {
                httpClient.patch(this.updateUrl, data)
                .then(response => {
                    vm.objectData = response.data;

                    for (const i in vm.$refs) {
                        const ref = vm.$refs[i];
                        if (ref && ref.hasOwnProperty('objectData') && ref.hasOwnProperty('setObjectData')) {
                            ref.setObjectData(response.data);
                        }
                    }

                    vm.clearForm();
                    // vm.objectKey = new Date().getTime();
                    vm.$bvToast.toast( `${objectLabel} обновлен`,
                        {noCloseButton: true, solid: true, autoHideDelay: 5000, variant: 'success'});
                    resolve(response);
                })
                .catch(reason => {
                    vm.showErrorToast(reason);
                    reject(reason);
                }).finally(() => {
                    vm.loading = false;
                });
            })
        },
        getBackendErrors(response) {
            let vn = [];
            const h = this.$createElement;
            for (const propIndex in Object.keys(response)) {

                let key = Object.keys(response)[propIndex];
                let labelKey = key;
                if (this.objectClass.hasOwnProperty('mapping')) {
                    for (const i in Object.keys(this.objectClass.mapping)) {
                        const k = Object.keys(this.objectClass.mapping)[i];
                        const v = this.objectClass.mapping[k];
                        if (v === key) {
                            labelKey = k;
                            break;
                        }
                    }
                }

                if (this.form.hasOwnProperty(labelKey)) {
                    this.$v.form[labelKey].$touch();
                }
                const fieldLabel = this.objectClass.validationFieldLabels.hasOwnProperty(labelKey) ? this.objectClass.validationFieldLabels[labelKey] : '';
                const reasons = response[key].join(', ');
                const item = fieldLabel ? fieldLabel + ': ' + reasons : reasons;
                vn.push(h('li', item));
            }
            return h('ul', vn);
        },
        setInvalidServerFields(data) {
            for (const k in Object.keys(this.form)) {
                const i = Object.keys(this.form)[k];
                const apiFieldName = this.getApiFieldName(i);
                // if (data.hasOwnProperty(apiFieldName)) {
                //     console.log(i, data[apiFieldName])
                // }
            }
        },
        showErrorToast(reason) {
            const title = this.header;
            let message;
            if (reason.response) {
                if (reason.response.status === 400) {
                    this.setInvalidServerFields(reason.response.data)
                    message = [this.getBackendErrors(reason.response.data)];
                } else if (reason.response.status === 500) {
                    message = 'Проблема на стороне сервера';
                } else if (reason.response.status === 502) {
                    message = 'Сервер перезапускается, попробуйте еще раз';
                } else if (reason.response.status === 403) {
                    message = 'Нет прав для выполнения операции';
                } else {
                    message = 'Неизвестная ошибка';
                }
                this.$bvToast.toast(message, {title: title, autoHideDelay: 5000, variant: 'danger'});
            }
        },
        getContextMenuBoundaries() {
            const el = document.getElementsByClassName('card-body')[0];
            if (el) return el.getBoundingClientRect();
            return null
        },
        onMount() {
            setTimeout(() => {
                const boundaries = this.getContextMenuBoundaries();
                this.$store.dispatch(UIConstants.UIActions.UI_CONTEXT_MENU_CONTAINER_SET_BOUNDARIES,
                    { boundaries: boundaries })
            }, 600);
        }
    },
    // mounted() {  // вызывалось дважды
    //     this.onMount();
    //     this.resetForm();
    // },
    beforeRouteLeave(to, from, next) {
        if (this.hasChanges && !this.silentLeave && this.$refs.leaveDialog) {
            this.$refs.leaveDialog.showConfirmLeave()
                .then(() => { next() })
                .catch(() => { next(false)});
        } else {
            next()
        }
    },
    watch: {
        '$v.form': {
            handler: function(newValue, oldValue) {
                if (newValue !== undefined) {
                    this.hasChanges = newValue.$anyDirty;
                    this.$emit('inline-form-state-changed', newValue.$anyDirty, this);
                }
            },
            deep: true
         },
    }
};

